import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { LoadingComponent } from '@components/loading/loading.component';
import { ComponentPortal } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingCount = 0;

  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay) { }

  /**
   * Método que pede para o serviço mostrar ou esconder o Loading.
   * O serviço usa um contador de chamadas de forma que chamadas aninhadas
   * não interfiram na chamada mais de fora. Ou seja, se setIsLoading
   * é chamada duas vezes seguidas com isLoading === true, o Loading
   * só vai sumir depois que for chamada duas vezes com isLoading === false.
   * Exceto no caso do parâmetro forced ser true, caso em que o contador
   * é zerado e o efeito pedido é sobreposto.
   *
   * @param isLoading flag que informa se é para exibir ou esconder o Loading.
   * @param forced flag que informa se é para sobrescrever o contador.
   * Só tem efeito se isLoading === false.
   */
  setIsLoading(isLoading: boolean, forced = false): void {
    if (isLoading) {
      this.loadingCount++;
    } else if (forced) this.loadingCount = 0;
    else this.loadingCount--;

    // Proteção caso haja mais chamadas pra fechar do que pra abrir
    if (this.loadingCount < 0) {
      /* eslint-disable no-console */
      console.warn('Loading Service: houve mais chamadas para fechar do que para abrir o Loading.');
      /* eslint-enable no-console */
      this.loadingCount = 0;
    }

    if (this.loadingCount !== 0) {
      if (this.overlayRef?.hasAttached()) return;

      this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
        hasBackdrop: true,
        backdropClass: 'backdrop',
        panelClass: 'loading'
      });

      this.overlayRef.attach(new ComponentPortal(LoadingComponent));
    } else {
      this.overlayRef?.dispose();
    }
  }
}
